import React from "react";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import { useModalStore } from "@/hooks/Modal/hooks";
import FrequentlyUsedOrderSearchCriteriaModal, {
    FrequentlyUsedOrderSearchEntity,
} from "../FrequentlyUsedOrderSearchCriteriaModal";
import SortableButtonList from "./SortableButtonList";

interface FrequentlyUsedOrderSearchPanelProps {
    shopId: number;
}

/**
 * 常用订单搜索面板组件
 */
const FrequentlyUsedOrderSearchPanel: React.FC<FrequentlyUsedOrderSearchPanelProps> = function (props) {
    const { shopId } = props;
    const { openModal } = useModalStore();

    return (
        <div style={{ flex: 1 }}>
            <span className="fs13" style={{ marginLeft: 6 }}>
                常用搜索&nbsp;:
            </span>

            <SortableButtonList entityId={shopId} entityType={FrequentlyUsedOrderSearchEntity.SHOP} />

            <Button
                onClick={() => {
                    openModal(FrequentlyUsedOrderSearchCriteriaModal, {
                        entityId: shopId,
                        entityType: FrequentlyUsedOrderSearchEntity.SHOP,
                    });
                }}
                size="small"
                className="ml10"
            >
                编辑
            </Button>
        </div>
    );
};

export default observer(FrequentlyUsedOrderSearchPanel);
